<template>
<div>
  <b-modal
        id="modal-whatsapp"
        cancel-variant="outline-secondary"
        centered
        ref="model-whatsapp"
        title="傳播訊息"
        no-close-on-backdrop
         scrollable
         hide-footer
      size="sm"
  >

  <b-form v-on:submit.prevent="whatsapp_submit(class_detail.id)">
          <b-row>
              <!-- email -->
              <b-col cols="12">
                <b-form-group label="訊息內容" label-for="message">
                  <b-form-textarea
                id="textarea-state"
                v-model="whatsapp"
                :state="whatsapp.length <= 200"
                placeholder="Enter only 200 characters"
                rows="4"
              />
                </b-form-group>
              </b-col>
              <!-- submit and reset -->
              <b-col cols="12" class="mt-1">
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mb-1" @click="whatsapp_submit(class_detail.id)" block>
                  確定
                </b-button>
              </b-col>
            </b-row>



        </b-form>
      </b-modal>
  <b-modal
        id="modal-aleave"
        cancel-variant="outline-secondary"
        centered
        ref="model-aleave"
        title="補堂"
        no-close-on-backdrop
         scrollable
         hide-footer
      size="sm"
  >

        <b-form v-on:submit.prevent="add_eleave(class_detail.id)">
          <b-row>
              <!-- email -->
              <b-col cols="12">
                <b-form-group label="學生編碼" label-for="lesson">
                  <b-form-input id="lesson" v-model="aleave_student" size="sm" />
                </b-form-group>
              </b-col>
              <!-- submit and reset -->
              <b-col cols="12" class="mt-1">
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mb-1" @click="add_eleave(class_detail.id)" block>
                  確定
                </b-button>
              </b-col>
            </b-row>



        </b-form>
      </b-modal>
      <b-modal
        id="modal-addstudent"
        cancel-variant="outline-secondary"
        centered
        ref="model-addstudent"
        title="新增學生"
        no-close-on-backdrop
         scrollable
         hide-footer
      size="sm"
  >

  <b-form v-on:submit.prevent="add_student(class_detail.id)">
          <b-row>
              <!-- email -->

              <b-col cols="12">
                <b-form-group label="學生編碼" label-for="lesson">
                  <b-form-input id="lesson" v-model="add_student_id" size="sm" />
                </b-form-group>
              </b-col>
              <!-- submit and reset -->
              <b-col cols="12" class="mt-1">
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mb-1" @click="add_student(class_detail.id)" block>
                  確定
                </b-button>
              </b-col>
            </b-row>



        </b-form>
      </b-modal>
  <b-modal
        id="modal-login"
        cancel-variant="outline-secondary"
        ok-title="確定"
        cancel-title="關閉"
        @ok="tstop"
        centered

        title="延伸月份"
      >
        <b-form>
          <b-form-group>
            <label for="請假月份">請假月份:</label>
            <div class="mb-1">{{unformat_date.substr(0,7)}}</div>
            <label for="email">延伸月份:</label>
            <b-form-spinbutton
              id="sb-default"
              placeholder="--"
              min='1'
              max='3'
              v-model="freeze_month"
              class="mb-1"
            />
          </b-form-group>
        </b-form>
      </b-modal>


      <b-modal
        id="modal-add-class"
        cancel-variant="outline-secondary"
        centered
        
        ref="modal-add-class"
        title="新增班次"
        no-close-on-backdrop
         scrollable
         hide-footer
      size="sm"
  >
        <b-form>
          <b-row>
              <!-- email -->
              <b-col cols="12">
                <b-form-group label="Date" label-for="Date">
                  <b-form-input id="class-date" placeholder="Class Date" disabled v-model="unformat_date" size="sm" />
                </b-form-group>
              </b-col>
              <b-col cols="12" v-if="$can('read', 'manager')">
                <b-form-group label="To" label-for="To">
                  <b-form-input v-model="add_class_form.end_date" size="sm" v-mask="'####-##-##'" placeholder="YYYY-MM-DD , blank if single class"/>
                </b-form-group>
              </b-col>
              <!--<b-col cols="12"> <b-form-group label="Class Type" label-for="type" > <b-form-input id="type" value="REGULAR" size="sm" v-model="class_detail.type" readonly
                                /> </b-form-group> </b-col>-->
                                <b-col cols="12">
                <b-form-group label="Class Name" label-for="Class Name">
                  <v-select v-model="add_class_form.class_list_id" :options="gradeOptionEnable" class="select-size-sm" :clearable="false" :filterable="true" input-id="Name" :reduce="class_list => class_list.id" />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Start Time" label-for="start">
                  <b-form-input id="start" v-mask="'##:##'" placeholder="Start Time (hh:ii)" v-model="add_class_form.start" size="sm" />
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group label="End Time" label-for="end">
                  <b-form-input id="end"  v-mask="'##:##'" placeholder="End Time (hh:ii)" v-model="add_class_form.end" size="sm" />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Room" label-for="Room">
                  <b-form-input id="Room" placeholder="Room Number" v-model="add_class_form.table" size="sm" />
                </b-form-group>
              </b-col>

             
              <b-col cols="12">
                <b-form-group label="Teacher" label-for="Teacher">
                  <v-select v-model="add_class_form.instructor" :options="teacherOption" class="select-size-sm" :clearable="false" :filterable="true" input-id="Client" :reduce="teacher => teacher.label" />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Maximum" label-for="Maximum">
                  <b-form-input id="Maximum" size="sm" v-model="add_class_form.maximum" placeholder="Maximum Number" />
                </b-form-group>
              </b-col>
              <!-- submit and reset -->
              <b-col cols="12" class="mt-1">
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mb-1" @click="add_class()" block>
                  確定
                </b-button>
              </b-col>
            </b-row>



        </b-form>
      </b-modal>

      <b-alert
      v-height-fade.appear
      variant="warning"
      :show="change_enrollment_id > 0"
      class="mb-1"
    >
      <div class="alert-body">
        <feather-icon
          icon="InfoIcon"
          class="mr-50"
        />
        已進入轉堂模式 <b-button variant='flat-primary' size="sm" @click="change_enrollment_id = 0">取消</b-button>
      </div>
    </b-alert>


  <!-- <Snapshot :is-snap-shot-sidebar-active.sync="isSnapShotSidebarActive" :user-data="userData" user-type="MEMBER" :enrollment="form" @clicked="two" /> -->
  <Sidebar :is-edit-enrollment-sidebar-active.sync="isEditEnrollmentSidebarActive" :form="form" :todo="todo" @clicked="one" @snapshot_now="snapshot_now" />
  <b-row>
    <b-col md="5">
      <!-- badge -->
      <b-card>
        <b-form-group>
          <b-row>
            <b-col cols="1" class="p-0">
              <b-button block="block" v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="btn-icon" variant="flat-primary" @click="minus_day(1)">
                <feather-icon icon="ChevronLeftIcon" />
              </b-button>
            </b-col>
            <b-col cols="10" class="p-0">
              <flat-pickr class="form-control" v-model="display_date" :config="{ altInput: true,altFormat: 'l F j, Y', dateFormat: 'Y-m-d',}" />
            </b-col>
            <b-col cols="1" class="p-0">
              <b-button block="block" v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="btn-icon" variant="flat-primary" @click="add_day(1)">
                <feather-icon icon="ChevronRightIcon" />
              </b-button>
            </b-col>
               <!-- <b-col cols="1" class="p-0">
              <b-button block="block" v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="btn-icon" variant="flat-primary" @click="timetable_print()">
                <feather-icon icon="PrinterIcon"/>
              </b-button>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col md="6">
              <!-- <b-badge @click="search('null')" variant="light-danger"  style="margin:3px 10px;padding:5px 20px;cursor:pointer;">ALL</b-badge>
              <b-badge v-for="(grade, index) in gradeOptionEnable" @click="search(grade.code)" variant="light-primary" :key="index" style="margin:3px 8px;padding:5px 8px;cursor:pointer;">{{grade.code}}</b-badge> -->
              <v-select :clearable="false" v-model="search_grade" :reduce="grade => grade.code" :options="gradeOptionEnableAll"></v-select>
            </b-col>
            <b-col md="6">
              <v-select :clearable="false" v-model="search_time" :options="['ALL','08','09','10','11','12','13','14','15','16','17','18','19','20']"></v-select>
            </b-col>
          </b-row>
        </b-form-group>
        <b-list-group>
          <!-- <vue-perfect-scrollbar
          ref="refChatLogPS"
          :settings="perfectScrollbarSettings"
          class="user-chats scroll-area"
        > -->
        <vue-custom-scrollbar class="scroll-area"  :settings="settings" @ps-scroll-y="scrollHanle">

          <b-list-group-item @click="selected_class(index);get_class_detail(class_detail.id,class_detail.class_date)" class="pointer" v-for="(class_detail, index) in classes.classes" :class="class_detail.selected_class" :style="'background-color:#'+class_detail.color" :key="index">
            <b-row>
              <b-col md="2">
                <div class="text-center">{{class_detail.start}}</div>
                <div class="text-center" style="border-top:1px solid #ccc">{{class_detail.end}}</div>
              </b-col>
              <b-col md="5">
                <div>
                  <b>{{class_detail.name}}
                    - {{class_detail.room_number}}</b>
                  <br>
                  {{class_detail.display_name}}
                  <b-badge variant="danger" v-if="class_detail.remarks != ''">{{ class_detail.remarks }}</b-badge>
                </div>
                <div v-if="class_detail.status == 'CANCELLED' || class_detail.status == 'DISABLED'" style="color:red;">{{class_detail.status}}</div>
              </b-col>
              <b-col md="5" class="text-right">
                <b-badge variant="primary" pill="pill" class="badge-round margin-05">
                  <span >{{class_detail.existing_booking}}</span>
                </b-badge>
                <!-- <b-badge pill="pill" class="bg-warning bg-darken-1 badge-round margin-05">
                  <span>{{class_detail.trial}}</span>
                </b-badge> -->
                <!-- <b-badge pill="pill" class="bg-secondary bg-darken-1 badge-round margin-05">
                  <span>{{class_detail.short_course}}</span>
                </b-badge> -->
                <b-badge pill="pill" class="bg-success bg-darken-1 badge-round margin-05">
                  <span>{{class_detail.makeup}}</span>
                </b-badge>
              </b-col>
            </b-row>
          </b-list-group-item>
        </vue-custom-scrollbar>
        </b-list-group>
        <hr />
        <b-button block class="mt-1" v-b-modal.modal-add-class>新增班次</b-button>
      </b-card>
    </b-col>
    <b-col md="7">

      <b-card :bg-variant="mode">
        <b-alert variant="danger" :show="class_detail.id == null">
          <div class="alert-body">
            <span>
              <strong>請選擇班別</strong>
            </span>
          </div>
        </b-alert>
        <b-row v-if="class_detail.id != null">
          <b-col md="3">
            <b-row>

              <!-- first name -->
              <b-col cols="12">
                <b-form-group label="Class ID" label-for="class-id" size="sm">
                  <b-form-input id="class-id" placeholder="Class ID" readonly="readonly" v-model="class_detail.id" size="sm" />
                </b-form-group>
              </b-col>

              <!-- email -->
              <b-col cols="12" v-if="class_detail.type != 'REGULAR'">
                <b-form-group label="Date" label-for="Date">
                  <b-form-input id="class-date" placeholder="Class Date" v-model="class_detail.class_date" size="sm" />
                </b-form-group>
              </b-col>

              <!--<b-col cols="12"> <b-form-group label="Class Type" label-for="type" > <b-form-input id="type" value="REGULAR" size="sm" v-model="class_detail.type" readonly
                                /> </b-form-group> </b-col>-->
              <b-col cols="12">
                <b-form-group label="Status" label-for="type">
                  <v-select v-model="class_detail.status" :options="statusOptions" :clearable="false" class="select-size-sm" :filterable="false" input-id="Client" :reduce="status => status.value" />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Start Time" label-for="start">
                  <b-form-input id="start"  v-mask="'##:##'" placeholder="Start Time (hh:ii)" v-model="class_detail.start" size="sm" />
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group label="End Time" label-for="end">
                  <b-form-input id="end"   v-mask="'##:##'" placeholder="End Time (hh:ii)" v-model="class_detail.end" size="sm" />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Room" label-for="Room">
                  <b-form-input id="room" placeholder="Room Number" v-model="class_detail.room_number" size="sm" />
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group label="Name" label-for="Name">
                  <v-select v-model="class_detail.name" :options="gradeOptionEnable" class="select-size-sm" :clearable="false" :filterable="true" input-id="Grade" :reduce="grade => grade.name" />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Teacher" label-for="Teacher">
                  <v-select v-model="class_detail.teacher_id" :options="teacherOption" class="select-size-sm" :clearable="false" :filterable="true" input-id="Client" :reduce="status => status.value" />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Maximum" label-for="Maximum">
                  <b-form-input id="Maximum" size="sm" v-model="class_detail.maximum" placeholder="Maximum Number" />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Group ID" label-for="GroupID">
                  <b-form-input id="group_id" size="sm" v-model="class_detail.group_id" placeholder="Maximum Number" disabled/>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Remarks" label-for="Remarks">
                  <b-form-input id="remarks"  size="sm" v-model="class_detail.remarks"/>
                </b-form-group>
              </b-col>
              <!-- submit and reset -->
              <b-col cols="12">
                <hr />
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-primary" class="mb-1" @click="update_class_detail('single')" block>
                  更新
                </b-button>
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mb-1" @click="update_class_detail('all')" block>
                  更新往後
                </b-button>
                <hr />
                <b-button v-if="$can('read', 'manager')" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="danger" class="mb-1" @click="confirmText(class_detail.id)" block>
                  刪除往後
                </b-button>
                <hr />
                <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="outline-danger" v-if="change_enrollment_id > 0" @click="change_enrollment(class_detail.id,'')" block>
                  轉堂
                </b-button>
                <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="danger" v-if="change_enrollment_id > 0" @click="change_enrollment(class_detail.id,'all')" block>
                 全部轉堂
                </b-button>
                <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" size="sm" variant="success"  @click="whatsapp_class(class_detail.id,)" block>
                 WhatsApp
                </b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="9">

            <b-list-group>
              <b-list-group-item v-for="(booking, index) in class_detail.booking" :key="index" :class="booking.enrollment_type">
                <b-row>
                  <b-col md="2" @click="open_sidebar(booking)">
                    <b-link  :to="'/apps/student/edit/'+booking.uuid+'/'">
                      <b :class="booking.card_color">{{booking.code}}</b><br>
                      <b-badge variant="light-primary">{{ booking.school_grade }}</b-badge> <span style="color:#888;display:none;">{{ age(booking.birth) }} </span>
                    </b-link>
                  </b-col>
                  <b-col md="5" @click="open_sidebar(booking)">
                    <span>
                     <b-badge variant="info">{{ booking.student_grade }}</b-badge> 
                     <b>{{booking.display_name}}</b><span v-if="booking.status == 'LEAVE'" style="color:#28c76f" >(請假)</span>
                     <feather-icon  v-if="booking.card_id == ''" icon="CastIcon" color="red" class="feather ml-1" />
                        
                    </span>
                    <br>
                   
                    <b-badge variant="secondary">{{booking.todo_content}}</b-badge>
                    <br>
                    <b-badge v-if="booking.change_from != null && booking.change_from != class_detail.id" variant="success">
                      {{ booking.change_from_class.class_date }} {{ booking.change_from_class.start }}
                    </b-badge>
                  </b-col>
                  <b-col md="5" class="text-right" v-if="booking.enrollment_type != 'REMOVED'">
                    <feather-icon v-if="$can('read', 'manager')" v-b-modal.modal-login @click="copy_id(booking.id,booking)" icon="TypeIcon" color="#00cfe8" class="feather mr-1 pointer" />
                    <feather-icon v-if="booking.locked !== true && booking.status != 'LEAVE' && booking.is_attend == null " @click="absent(booking.id)" icon="XIcon" color="red" class="feather mr-1 pointer" />
                    <feather-icon v-if="booking.locked !== true && booking.status == 'LEAVE' && booking.is_attend == null " @click="rollback_absent(booking.id)" icon="EyeIcon" style="color:#28c76f" color="warning" class="feather mr-1 pointer" />
                    <feather-icon v-if="booking.locked !== true && booking.is_attend !='Y' && booking.status != 'LEAVE' " @click="change(booking.id)" icon="CornerDownRightIcon" style="color:#0065b5" class="feather mr-1 pointer" />
                    <feather-icon v-if="booking.locked !== true && booking.status != 'LEAVE' && booking.is_attend !='Y' " @click="attend(booking.id)" icon="CheckSquareIcon" color="green" class="feather mr-1 pointer" />
                    <feather-icon v-if="booking.is_attend =='Y' " icon="CheckIcon" color="blue" class="feather pointer" @click="attend_undo(booking.id)" />
                  </b-col>
                </b-row>
              </b-list-group-item>

            </b-list-group>
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="warning" class="my-2" v-b-modal.modal-aleave block>
                新增補堂學生
            </b-button>
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="my-2" v-b-modal.modal-addstudent block>
                新增未付款學生
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-col>

  </b-row>
</div>
</template>

<script>
import {
  BLink,
  BAlert,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormTextarea,
  BTable,
  BListGroup,
  BListGroupItem,
  BFormSelect,
  BBadge,
  BRow,
  BCol,
  BCard,
  BFormSpinbutton,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'
import Sidebar from './SideBarBooking.vue'
import Snapshot from './SidebarSnapshot.vue'
import { ref } from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import "vue-custom-scrollbar/dist/vueScrollbar.css"
export default {
  components: {
    Snapshot,
    BFormSpinbutton,
    BLink,
    Sidebar,
    BInputGroup,
    vueCustomScrollbar,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormTextarea,
    flatPickr,
    BAlert,
    BTable,
    vSelect,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormCheckbox,
    BForm,
    BButton,
    BCard,
    BBadge,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
  },
  directives: {
    Ripple,
  },
  watch: {

    display_date() {
      this.get_date_class(this.display_date)
    },
    change_enrollment_id : {
      handler(newValue, oldValue) {
        if ( newValue > 0 ) {
          this.mode = 'warning bg-lighten-5'
        } else {
          this.mode = ''
        }
      }
    },
    search_time: {
      handler(newValue, oldValue) {
        this.get_date_class(this.unformat_date)
      }
    },
    search_grade: {
      handler(newValue, oldValue) {
        this.search(newValue)
      }
    },
  },
  computed: {
    filterSectionHeight() {
      const filterSectionDOM = document.getElementById("filterSection");
      return filterSectionDOM ? filterSectionDOM.offsetHeight : 0;   
    },
    unformat_date() {
      return moment(this.display_date).format('YYYY-MM-DD')
    }
  },
  data() {
    return {
      whatsapp:'',
      settings: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: true
      },
      classes: [],
      mode: '',
      gradeOptionEnable: [],
      gradeOptionEnableAll: [],
      freeze_month:1,
      perfectScrollbarSettings: {
        maxScrollbarLength: 60
      },
      search_time:'ALL',
      search_grade: 'ALL',
      selected_booking:null,
      change_enrollment_id: 0,
      tstop_booking_id:null,
      aleave_student:null,
      add_student_id:null,
      isEditEnrollmentSidebarActive: false,
      form: {
        class_id: null,
        member_code: null,
        class_data: null
      },
      add_class_form: {
        class_date : null,
        start: null,
        center_id : null,
        table:null,
        end: null,
        type: null,
        start_date: null,
        end_date:null,
        grade: null,
        instructor: null,
        maximum: 20,
        waiting: 20,
        minimum: 0
      } ,
      isSnapShotSidebarActive: false,
      display_date: moment(this.nowDate).format('dddd YYYY-MM-DD'),
      nowDate: new Date().getTime(),
      form: null,
      class_detail: {
        id: null,
        class_date: null,
        type: null,
        start: null,
        end: null,
        week_number: null,
        name: null,
        tutor: null,
        maximum: null,
        waiting: null
      },
      perPage: null,
      teacherOption: [],
      weekOptions: [{
          label: "SUNDAY",
          value: "0"
        },
        {
          label: "MONDAY",
          value: "1"
        },
        {
          label: "TUESDAY",
          value: "2"
        },
        {
          label: "WEDNESDAY",
          value: "3"
        },
        {
          label: "THURSDAY",
          value: "4"
        },
        {
          label: "FRIDAY",
          value: "5"
        },
        {
          label: "SATURDAY",
          value: "6"
        }
      ],
      gradeOption:[],
      statusOptions: [{
          label: "ACTIVE",
          value: "ACTIVE"
        },
        {
          label: "DISABLED",
          value: "DISABLED"
        },
        {
          label: "CANCELLED",
          value: "CANCELLED"
        },
        {
          label: "DELETED",
          value: "DELETED"
        }
      ],
    }
  },
  created() {
    console.clear();
    if (this.$route.query.enrollment_id > 0) { 
      console.log("change mode")
      this.change(this.$route.query.enrollment_id )
    }
    this.get_date_class(moment(this.nowDate).format('YYYY-MM-DD'))
    this.get_teacher()
    this.get_grade()
  },
  methods: {
    whatsapp_class(class_id) {
      this.$refs['model-whatsapp'].show()
    },
    whatsapp_submit() {
      this.$http.post(process.env.VUE_APP_API_BASE + '/class/' + this.class_detail.id + '/whatsapp/', {
        "whatsapp" : this.whatsapp
      } ).then(res => {
        if (res.data.result === true) {
            this.$refs['model-whatsapp'].hide()
            //this.get_date_class(this.unformat_date)
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
         }
      })
    },
    scrollHanle(evt) {
      console.log(evt)
    },
    open_sidebar(booking) {
      this.form = booking
      this.$http.get(process.env.VUE_APP_API_BASE+'/student/'+this.form.uuid+'/todo/?selected_class_id='+booking.id)
        .then(res => {
          if (res.data.result === true) {
           this.todo = res.data.todo 
           this.isEditEnrollmentSidebarActive = true
          }
        })
      
    },
    load_todo() {
     
    },
    age(dob) {
     // return dob+" "+moment().diff( dob, 'months',false)
      var a = moment();
      var b = moment(dob, 'YYYY-MM-DD');
      var age = moment.duration(a.diff(b));
      var years = age.years();
      var months = age.months();
      var month_string = ''
      if (months > 0 ) { month_string = months + "個月" }
      return  years + "歲 " + month_string 
    },
    selected_class(index) {
      
      this.classes.classes.forEach(element => {
        element.selected_class = null
      })
      this.classes.classes[index].selected_class = 'selected_class'
      console.log(this.classes)
    },
    search(grade) {
      this.search_grade = grade
      this.get_date_class(moment(this.display_date).format('YYYY-MM-DD'))
    },
    get_grade() {
      this.$http.get(process.env.VUE_APP_API_BASE + '/grades/')
        .then(res => {
          this.gradeOption = res.data.grades
          this.gradeOptionEnable  = this.gradeOptionEnableAll = res.data.grades_enable
          let a = {grade_id: "all", code: "ALL", zh_name: "全部", en_name: "ALL", color: "FFF6ED" , label: "ALL - 全部"}
          this.gradeOptionEnableAll.unshift(a)
         
        })
    },
    snapshot_now() {
      this.isSnapShotSidebarActive = true
    },
    get_teacher() {
      this.$http.get(process.env.VUE_APP_API_BASE + '/staffs/select/')
        .then(res => {
          this.teacherOption = res.data
          // this.display_date = res.data.date_formated
        })
    },
    one() {
      this.isEditEnrollmentSidebarActive = false
      this.get_class_detail(this.class_detail.id, this.form.class_date)
      this.get_date_class(this.form.class_date)
    },
    two() {
      this.isSnapShotSidebarActive = false
    },
    timetable_print() {
      var d = this.display_date.substr(this.display_date.length - 10)
      //window.open("//rb.cloudedu.pro/timetable.php?token="+ JSON.parse(localStorage.getItem('userData')).token +"&date="+ moment(this.display_date).format('YYYY-MM-DD') +"&center_id="+this.$store.getters['center/currentCenterId'],"_blank")
      window.open("//rb.cloudedu.pro/timetable.php?token="+ JSON.parse(localStorage.getItem('userData')).token +"&date=" + d + "&center_id="+this.$store.getters['center/currentCenterId'],"_blank")
    },
    change(id) {
      window.scrollTo(0,0);
      this.color = 'yellow'
      this.change_enrollment_id = id
    },
    add_student(class_id) {
      this.$http.post(process.env.VUE_APP_API_BASE + '/class/' + class_id + '/add/', {
        "student" : this.add_student_id
      } ).then(res => {
        if (res.data.result === true) {
            this.$refs['model-addstudent'].hide()
            //this.get_date_class(this.unformat_date)
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
         }
          this.get_class_detail(res.data.class.id, res.data.class.class_date)
          this.get_date_class(res.data.class.class_date)
          this.add_student_id = null
      })
    },
    add_eleave(class_id) {
      this.$http.post(process.env.VUE_APP_API_BASE + '/class/' + class_id + '/eleave_add/', {
        "student" : this.aleave_student
      } ).then(res => {
        if (res.data.result === true) {
            this.$refs['model-aleave'].hide()
            //this.get_date_class(this.unformat_date)
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
         }
          this.get_class_detail(res.data.class.id, res.data.class_date)
          this.get_date_class(res.data.class_date)
          this.aleave_student = null
      })
    },
    tstop() {
      this.$http.post(process.env.VUE_APP_API_BASE + '/transaction/' + this.selected_booking.transaction_id + '/freeze/', {
        freeze_year_month : this.unformat_date.substr(0,7),
        freeze_period_month : this.freeze_month
      } ).then(res => {

          this.get_class_detail(this.class_detail.id, this.form.class_date)
          this.get_date_class(this.form.class_date)
        })
    },
    add_class() {
      if (this.add_class_form.end_date != null) {
        this.add_class_form.type = 'REGULAR'
      }
      this.add_class_form.class_date = this.unformat_date
      this.add_class_form.start_date = this.unformat_date
      this.add_class_form.center_id = this.$store.getters['center/currentCenterId']
      let data1 = new Array();
      data1.push(this.add_class_form)
      this.$http.post(process.env.VUE_APP_API_BASE + '/class/import/',  {'center_id': this.$store.getters['center/currentCenterId'],'data' : data1 } ).then(res => {
        if (res.data.result === true) {
            this.get_date_class(this.unformat_date)
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
            this.$refs['modal-add-class'].hide()
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
         }
        })
    },
    change_enrollment(class_id,type) {
      this.$http.post(process.env.VUE_APP_API_BASE + '/enrollment/' + this.change_enrollment_id + '/change_class/?type=' + type, {
          target_class: class_id
        })
        .then(res => {
          this.change_enrollment_id = 0
         // this.get_class_detail(this.class_detail.id, this.form.class_date)
         // this.get_date_class(this.form.class_date)
        this.get_class_detail(res.data.id, res.data.class_date)
        this.get_date_class(res.data.class_date)
        })
    },
    copy_id(id,booking) {
      console.log("start")
      this.selected_booking = booking
      this.tstop_booking_id = id
      console.log(this.tstop_booking_id)
    },
    minus_day(day) {
      this.display_date = moment(this.display_date).subtract(day, 'days').format('YYYY-MM-DD')
    },
    add_day(day) {
      this.display_date = moment(this.display_date).add(day, 'days').format('YYYY-MM-DD')
    },
    get_date_class(date) {
      this.$http.get(process.env.VUE_APP_API_BASE + '/classes/' + this.$store.getters['center/currentCenterId'] + '/' + date + '/?grade='+this.search_grade+'&time='+this.search_time)
        .then(res => {
          this.classes = res.data
          // this.display_date = res.data.date_formated
        })
    },
    absent(booking_id) {
      this.$http.post(process.env.VUE_APP_API_BASE + '/enrollment/' + booking_id + '/absent/')
        .then(res => {
          this.class_detail = res.data
          this.form.class_id = res.data.id
          this.form.class_date = res.data.class_date
          this.get_class_detail(this.class_detail.id, this.form.class_date)
        })
    },
    rollback_absent(booking_id) {
      this.$http.post(process.env.VUE_APP_API_BASE + '/enrollment/' + booking_id + '/absent/?action=rollback')
        .then(res => {
          this.class_detail = res.data
          this.form.class_id = res.data.id
          this.form.class_date = res.data.class_date
          this.get_class_detail(this.class_detail.id, this.form.class_date)
        })
    },
    get_class_detail(class_id, class_date) {
      this.$http.get(process.env.VUE_APP_API_BASE + '/class/' + class_id + '/?class_date=' + class_date)
        .then(res => {
          this.class_detail = res.data
          this.form.class_id = res.data.id
          this.form.class_date = res.data.class_date
        })
    },
    attend(booking_id) {
      this.$http.post(process.env.VUE_APP_API_BASE + '/enrollment/' + booking_id + '/attend/')
        .then(res => {
          this.class_detail = res.data
          this.form.class_id = res.data.id
          this.form.class_date = res.data.class_date
          this.get_class_detail(this.class_detail.id, this.form.class_date)
        })
    },
    attend_undo(booking_id) {
      this.$http.post(process.env.VUE_APP_API_BASE + '/enrollment/' + booking_id + '/attend/?action=undo')
        .then(res => {
          if (res.data.result === true) {
            this.class_detail = res.data
            this.form.class_id = res.data.id
            this.form.class_date = res.data.class_date
            this.get_class_detail(this.class_detail.id, this.form.class_date)
          }
        })
    },
    update_class_detail(action) {

      this.$http.post(process.env.VUE_APP_API_BASE + '/class/update/?action='+action, this.class_detail)
        .then(res => {
          if (res.data.result === true) {
            this.get_date_class(this.unformat_date)
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.get_date_class(this.unformat_date)
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    confirmText(class_id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.delete_class(class_id)
        }
      })
    },
    delete_class(class_id) {
      this.$http.post(process.env.VUE_APP_API_BASE + '/class/' + class_id + '/delete/all_in_future/')
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
            this.class_detail = {
                id: null,
                class_date: null,
                type: null,
                start: null,
                end: null,
                week_number: null,
                name: null,
                tutor: null,
                maximum: null,
                waiting: null
              },
              this.get_date_class(res.data.class_date)
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    delete_booking(booking_id) {
      this.$http.post(process.env.VUE_APP_API_BASE + '/booking/' + booking_id + '/delete/')
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
            this.get_class_detail(this.form.class_id, this.form.class_date)
            this.get_date_class(this.form.class_date)
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    }
  }
}
</script>
 <style>
    .pointer {
        cursor : pointer;
    }
    .form-group {
      margin-bottom:.3rem;
    }
 </style>
 <style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.TRIAL {
background-color: #fbff9fc2;
}
.REMOVED {
  background-color:#fb8a8a
}
.NONPAID {
background-color: #9fc7ffc2;
}
.feather {
  width: 20px;
  height: 20px;
}
.pointer {
  cursor: pointer;
}
.selected_class {
  border:5px solid #9a0000 !important;
}
.margin-05 {
  margin-right:0.5rem !important;
}
.scroll-area {
  position: relative;
  height: 54vh;
}
.ps__rail-y {
  z-index:99999;
}
.v-select {
  background: #fff;
}
</style>
